/**
 * Translated route slugs for NL and EN.
 * Dutch is the default (no prefix needed), English gets /en prefix.
 * Dashboard and admin routes stay untranslated (behind auth).
 */

export interface RouteConfig {
  nl: string;
  en: string;
  /** If true, this route is behind auth and doesn't get language prefix */
  protected?: boolean;
}

export const publicRoutes: RouteConfig[] = [
  { nl: "/", en: "/" },
  { nl: "/bestellen", en: "/order" },
  { nl: "/bestellen/eps", en: "/order/eps" },
  { nl: "/bestellen/container", en: "/order/container" },
  { nl: "/bestelling-succes", en: "/order-success" },
  { nl: "/betaling-succes", en: "/payment-success" },
  { nl: "/planning-configuratie", en: "/planning-config" },
  { nl: "/over-ons", en: "/about" },
  { nl: "/contact", en: "/contact" },
  { nl: "/faq", en: "/faq" },
  { nl: "/oplossingen/horeca-catering", en: "/solutions/hospitality-catering" },
  { nl: "/oplossingen/medisch-farmaceutisch", en: "/solutions/medical-pharmaceutical" },
  { nl: "/oplossingen/transport-logistiek", en: "/solutions/transport-logistics" },
  { nl: "/oplossingen/voedselindustrie", en: "/solutions/food-industry" },
  { nl: "/oplossingen/industrieel-reinigen", en: "/solutions/industrial-cleaning" },
  { nl: "/oplossingen/evenementen", en: "/solutions/events" },
  { nl: "/track", en: "/track" },
  { nl: "/algemene-voorwaarden", en: "/terms" },
  { nl: "/privacy", en: "/privacy" },
  { nl: "/offerte", en: "/quote" },
  { nl: "/kennisbank", en: "/knowledge-base" },
  { nl: "/kennisbank/wat-is-droogijs", en: "/knowledge-base/what-is-dry-ice" },
  { nl: "/kennisbank/veilig-werken-met-droogijs", en: "/knowledge-base/working-safely-with-dry-ice" },
  { nl: "/kennisbank/droogijs-opslaan", en: "/knowledge-base/storing-dry-ice" },
  { nl: "/kennisbank/droogijs-voor-voedselvervoer", en: "/knowledge-base/dry-ice-for-food-transport" },
  { nl: "/kennisbank/levering-en-logistiek", en: "/knowledge-base/delivery-and-logistics" },
  { nl: "/kennisbank/industriele-reiniging", en: "/knowledge-base/industrial-cleaning" },
  { nl: "/kennisbank/droogijs-medische-verzendingen", en: "/knowledge-base/dry-ice-medical-shipping" },
  { nl: "/kennisbank/droogijs-vs-gel-packs", en: "/knowledge-base/dry-ice-vs-gel-packs" },
  { nl: "/kennisbank/droogijs-evenementen-horeca", en: "/knowledge-base/dry-ice-events-hospitality" },
  { nl: "/kennisbank/duurzaamheid-droogijs", en: "/knowledge-base/dry-ice-sustainability" },
  { nl: "/kennisbank/hoeveel-droogijs-nodig", en: "/knowledge-base/how-much-dry-ice" },
  { nl: "/kennisbank/droogijs-verpakken-verzenden", en: "/knowledge-base/packaging-shipping-dry-ice" },
  { nl: "/kennisbank/droogijs-bewaren-zomer", en: "/knowledge-base/storing-dry-ice-summer" },
  { nl: "/kennisbank/kosten-droogijs-per-kg", en: "/knowledge-base/dry-ice-cost-per-kg" },
  { nl: "/kennisbank/droogijs-laboratorium", en: "/knowledge-base/dry-ice-laboratory" },
  { nl: "/kennisbank/droogijs-bloemisterij", en: "/knowledge-base/dry-ice-florists" },
  { nl: "/kennisbank/droogijs-farmaceutische-industrie", en: "/knowledge-base/dry-ice-pharmaceutical" },
  { nl: "/kennisbank/droogijs-wijnkoeling", en: "/knowledge-base/dry-ice-wine-cooling" },
  { nl: "/kennisbank/droogijs-rookeffecten-theater", en: "/knowledge-base/dry-ice-smoke-effects" },
  { nl: "/kennisbank/droogijs-ijssalon-bevroren-desserts", en: "/knowledge-base/dry-ice-ice-cream" },
  { nl: "/kennisbank/droogijs-luchtvaart-luchtvracht", en: "/knowledge-base/dry-ice-aviation" },
  { nl: "/kennisbank/droogijs-halloween-feesten", en: "/knowledge-base/dry-ice-halloween" },
  { nl: "/kennisbank/droogijs-feestdagen-kerst", en: "/knowledge-base/dry-ice-holidays" },
  { nl: "/kennisbank/droogijs-temperatuurregistratie", en: "/knowledge-base/dry-ice-temperature-monitoring" },
  { nl: "/kennisbank/droogijs-visverwerking", en: "/knowledge-base/dry-ice-fish-processing" },
  { nl: "/kennisbank/droogijs-automotive-industrie", en: "/knowledge-base/dry-ice-automotive" },
  { nl: "/kennisbank/droogijs-catering-bedrijven", en: "/knowledge-base/dry-ice-catering" },
  { nl: "/kennisbank/droogijs-pellets-vs-blokken", en: "/knowledge-base/dry-ice-pellets-vs-blocks" },
  { nl: "/kennisbank/droogijs-ecommerce-verzendingen", en: "/knowledge-base/dry-ice-ecommerce" },
  { nl: "/kennisbank/droogijs-opslag-tips-bedrijven", en: "/knowledge-base/dry-ice-business-storage" },
  { nl: "/kennisbank/droogijs-gender-reveal", en: "/knowledge-base/dry-ice-gender-reveal" },
  { nl: "/droogijs-kopen-amsterdam", en: "/buy-dry-ice-amsterdam" },
  { nl: "/droogijs-kopen-rotterdam", en: "/buy-dry-ice-rotterdam" },
  { nl: "/droogijs-kopen-den-haag", en: "/buy-dry-ice-the-hague" },
  { nl: "/droogijs-kopen-utrecht", en: "/buy-dry-ice-utrecht" },
  { nl: "/droogijs-kopen-eindhoven", en: "/buy-dry-ice-eindhoven" },
  { nl: "/droogijs-kopen-groningen", en: "/buy-dry-ice-groningen" },
  { nl: "/droogijs-kopen-tilburg", en: "/buy-dry-ice-tilburg" },
  { nl: "/droogijs-kopen-almere", en: "/buy-dry-ice-almere" },
  { nl: "/droogijs-kopen-breda", en: "/buy-dry-ice-breda" },
  { nl: "/droogijs-kopen-arnhem", en: "/buy-dry-ice-arnhem" },
  { nl: "/login", en: "/login" },
  { nl: "/signup", en: "/signup" },
  { nl: "/forgot-password", en: "/forgot-password" },
  { nl: "/reset-password", en: "/reset-password" },
  { nl: "/links", en: "/links" },
];

/**
 * Given a path in one language, find the equivalent path in the other language.
 */
export function getTranslatedPath(currentPath: string, fromLang: "nl" | "en", toLang: "nl" | "en"): string {
  // Strip /en prefix if present
  const cleanPath = fromLang === "en" ? currentPath.replace(/^\/en(?=\/|$)/, "") || "/" : currentPath;

  const route = publicRoutes.find((r) => r[fromLang] === cleanPath);
  if (!route) return toLang === "en" ? `/en${currentPath}` : currentPath;

  const targetPath = route[toLang];
  return toLang === "en" ? `/en${targetPath}` : targetPath;
}

/**
 * Detect language from URL path.
 */
export function detectLanguageFromPath(pathname: string): "nl" | "en" | null {
  if (pathname.startsWith("/en/") || pathname === "/en") return "en";
  return null; // Default to NL (no prefix)
}

/**
 * Get the NL path from an EN path (strip /en prefix and look up).
 */
export function getPathWithoutLangPrefix(pathname: string): string {
  if (pathname.startsWith("/en/")) return pathname.slice(3) || "/";
  if (pathname === "/en") return "/";
  return pathname;
}
